// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AutocompleteTagsController from "./autocomplete_tags_controller"
application.register("autocomplete-tags", AutocompleteTagsController)

import EstimationController from "./estimation_controller"
application.register("estimation", EstimationController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LexiqueController from "./lexique_controller"
application.register("lexique", LexiqueController)

import MapController from "./map_controller"
application.register("map", MapController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)
